import React from 'react';
import './Grid.css';
import { useNavigate } from 'react-router-dom';

const Grid = () => {
  const navigate = useNavigate();

  return (
    <div className="grid-container">
      <div className="grid-heading">What we do</div>
      <div className="grid-underline"></div>
      <div className="grid-maintitle">Services</div>

      {/* Visible only on desktop */}
      <p className="grid-paragraph desktop-only">
        At Spatial Computing Technologies (SpatialCT), we harness the power of spatial computing and
        XR (Extended Reality) to build high-impact immersive solutions tailored for industries, academia,
        and institutions. Our services blend realism, interactivity, and intelligence to improve learning,
        training, collaboration, and operational efficiency.
      </p>

      {/* Visible only on mobile */}
      {/* <p className="grid-paragraph2 mobile-only">
        Immersive Solutions Designed for the Future of Work and Learning
      </p> */}

      <div className="grid-gridcontainer">
        <div className="grid-card">
          <div className="grid-content">
            <h3 className="grid-title">Industries</h3>
            <p className="grid-description">
              Transform operations and training with spatial computing and XR.
            </p>
            <ul className="page4-list">
               <li>XR Awareness Workshops</li>
               <li>Immersive Walk-throughs & Simulations</li>
               <li>Immersive Skill Training</li>
               <li>Remote XR Collaboration</li>
               <li>Spatial Monitoring & Management Systems</li>
               </ul>
            <span
              className="read-more"
              onClick={() => navigate('/services/industries')}
              role="button"
              tabIndex={0}
              onKeyPress={e => e.key === 'Enter' && navigate('/services/industries')}
            >
              Read More →
            </span>
          </div>
          <img src="/images/ind_monitor.webp" alt="Industries" className="grid-image" />
        </div>

        <div className="grid-card">
          <div className="grid-content">
            <h3 className="grid-title">Academia</h3>
            <p className="grid-description">
              Empowering faculty and learners with immersive education tools.
            </p>
            <ul className="page4-list">
               <li>XR Awareness & Faculty Development</li>
               <li>Virtual Labs & Simulation Modules</li>
               <li>XR-Enabled Learning Content</li>
               <li>Multi-User Learning Environments</li>
               <li>Academic Innovation Labs</li>
               </ul>
            <span
              className="read-more"
              onClick={() => navigate('/services/academia')}
              role="button"
              tabIndex={0}
              onKeyPress={e => e.key === 'Enter' && navigate('/services/academia')}
            >
              Read More →
            </span>
          </div>
          <img src="/images/aca_content.webp" alt="Academia" className="grid-image" />
        </div>

        <div className="grid-card">
          <div className="grid-content">
            <h3 className="grid-title">XR Infrastructure</h3>
            <p className="grid-description">
              Power your spatial experiences with robust XR labs and centers.
            </p>
              <ul className="page4-list">
                  <li>Immersive Exhibits for Museums & Theme Parks</li>
                  <li>XR Experience Centers</li>
                  </ul>
            <span
              className="read-more"
              onClick={() => navigate('/services/xrinfrastructure')}
              role="button"
              tabIndex={0}
              onKeyPress={e => e.key === 'Enter' && navigate('/services/xrinfrastructure')}
            >
              Read More →
            </span>
          </div>
          <img src="/images/inf_museum.webp" alt="XR Infrastructure" className="grid-image" />
        </div>
      </div>

      <div className="grid-featureCard">
        <h2 className="grid-maintitle2">Research & Innovation</h2>
        <p className="grid-paragraph">
          At Spatial Computing Technologies (SpatialCT), we partner with academic institutions and
          corporate R&D labs to advance the frontiers of immersive technology. Our research spans
          foundational studies in human perception and interaction to applied innovations that solve real-world industrial challenges.
        </p>
        <p className="grid-paragraph2">
          Shaping the future of XR Through Applied Research and Strategic Collaboration
        </p>

        <div className="grid-featureItem">
          <div className="grid-featureText">
            <h2 className='strong'><strong>Academic Collaborations</strong></h2>
            <p>
              We work closely with educational institutions to explore how immersive technologies transform learning, cognition, and accessibility.
            </p>
            <span
              className="read-more"
              onClick={() => navigate('/ResearchAndInnovation/academiccollaborations')}
              role="button"
              tabIndex={0}
              onKeyPress={e => e.key === 'Enter' && navigate('/ResearchAndInnovation/academiccollaborations')}
            >
              Read More →
            </span>
          </div>
          <div className="grid-featureImage">
            <img src="/images/Academic_R&D.webp" alt="Academic Research and Development" />
          </div>
        </div>
       <br />
        <div className="grid-featureItem">
          <div className="grid-featureImage">
            <img src="/images/Corporate_R&D.webp" alt="Corporate Research and Development" />
          </div>
          <div className="grid-featureText">
            <h2 className='strong'><strong>Corporate Research and Innovation Programs</strong></h2>
            <p>
              We collaborate with industry leaders to drive innovations across product development, safety, and smart operations.
            </p>
            <span
              className="read-more"
              onClick={() => navigate('/ResearchAndInnovation/CorporateR&DPrograms')}
              role="button"
              tabIndex={0}
              onKeyPress={e => e.key === 'Enter' && navigate('/ResearchAndInnovation/CorporateR&DPrograms')}
            >
              Read More →
            </span>
          </div>
        </div>
        <br />
           <div className='grid-featureCard'>
        <h5 className="grid-maintitle">School of Spatial Computing</h5>
       <h5 className="grid-subtitle1">Shaping the Future of Immersive Tech Talent</h5>
       <br />
        <p className='grid-paragraph3'>SpatialCT’s School of Spatial Computing is a learning and knowledge-sharing hub designed to empower students, educators, and professionals to master the tools, concepts, and innovations driving the XR revolution.</p> 
        <p className="coming-soon1">Coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default Grid;
